module.exports = require("@wordpress/dom");